/**
 * Filtering and ordering for the reviews list.
 *
 * Everything is already in the page — the section renders every review from the
 * product's metafield — so this only hides and reorders what is there. With no
 * script the full list shows in the order it was written, which is the honest
 * fallback: nothing is missing, only the controls are.
 */
class KarvingerReviews extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-list]');
    this.nomatch = this.querySelector('[data-nomatch]');
    this.chips = Array.from(this.querySelectorAll('[data-filter]'));
    this.select = this.querySelector('[data-sort]');
    if (!this.list) return;

    this.reviews = Array.from(this.list.querySelectorAll('.k-review'));
    this.filter = 'all';

    for (const chip of this.chips) {
      chip.addEventListener('click', () => {
        this.filter = chip.dataset.filter;
        this.apply();
      });
    }

    if (this.select) this.select.addEventListener('change', () => this.apply());

    this.apply();
  }

  apply() {
    let shown = 0;
    for (const review of this.reviews) {
      const rating = Number(review.dataset.rating);
      const verified = review.dataset.verified === 'true';
      let keep = true;
      if (this.filter === '5') keep = Math.round(rating) === 5;
      else if (this.filter === '4') keep = Math.round(rating) === 4;
      else if (this.filter === 'low') keep = Math.round(rating) <= 3;
      else if (this.filter === 'verified') keep = verified;
      review.hidden = !keep;
      if (keep) shown++;
    }

    for (const chip of this.chips) {
      chip.classList.toggle('k-tag--selected', chip.dataset.filter === this.filter);
      chip.setAttribute('aria-pressed', chip.dataset.filter === this.filter ? 'true' : 'false');
    }

    if (this.nomatch) this.nomatch.hidden = shown !== 0;

    const sort = this.select ? this.select.value : 'recent';
    const ordered = this.reviews.slice().sort((a, b) => {
      if (sort === 'high') return Number(b.dataset.rating) - Number(a.dataset.rating);
      if (sort === 'low') return Number(a.dataset.rating) - Number(b.dataset.rating);
      // Undated reviews sink rather than jumping to the top on an empty string.
      const da = Date.parse(a.dataset.date) || 0;
      const db = Date.parse(b.dataset.date) || 0;
      return db - da;
    });
    for (const review of ordered) this.list.appendChild(review);
  }
}

if (!customElements.get('karvinger-reviews')) {
  customElements.define('karvinger-reviews', KarvingerReviews);
}
